<template>
<div>
    <div class="row">
        <div class="col-lg-12">
            <form>
                <card>
                    <template slot="header">
                        <h3 class="card-title">{{$t('clarifications.request_for_clarifications')}}</h3>
                    </template>
                    <h4 v-if="proposal.id">Your reference: {{referenceNr}}</h4>
                    <div class="row">
                        <div class="col-lg-12">
                            <question-box v-if="proposal.id" :call-id="callId" :proposal="proposal"></question-box>
                        </div>
                    </div>
                </card>
            </form>
        </div>
    </div>
</div>
</template>
<script>
import {
    UserService,
    ProposalService,
    UserRoles
} from '@/services';
import swal from 'sweetalert2';
import {
    QuestionBox
} from 'src/components';

export default {
    components: {
        QuestionBox
    },
    data() {
        return {
            application: {},
            clarification: {},
            questions: [],
            referenceNr: '-',
            proposal: {},
            userDetails: {},
            loggedUser: {},
            userId: parseInt(this.$route.params.userId),
            proposalId: parseInt(this.$route.params.userId),
            callId: parseInt(this.$route.params.callId),
        }
    },
    methods: {
        async getProposal()
        {
            let vm = this;
            let loader = vm.$loading.show();

            await ProposalService.getProposal(vm.proposalId).then(function (response)
            {
                vm.proposal = response.data;
            });

            loader.hide();
        },
        async getUserDetails() {
            let vm = this;
            let loader = vm.$loading.show();

            await UserService.getUserDetails(vm.userId).then(function(response) {
                vm.userDetails = response.data;
            });

            loader.hide();
        },
    },
    beforeMount() {
        let vm = this;
        vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
    },
    async mounted() {
        let vm = this;

        await vm.getProposal();

        vm.referenceNr = vm.proposal.reference;
    }
};
</script>
<style lang="scss" scoped>
.lang-input {
    width: 80%;
}

.flag-icon {
    font-size: 1.5rem;
}

.mail-sample-image {
    img {
        max-width: 80%;
    }
}

textarea {
    width: 100%;
    resize: both;
    max-height: none !important;
    height: 150px;

    &.subject,
    &.textarea-email {
        height: auto !important;
        width: 100%;
    }
}
</style>
